<script setup lang="ts">
import { Navigation, Pagination, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Skeleton } from '~/components/ui/skeleton';

interface Props {
  heading: string;
  category?: string;
  id_category_default?: number;
}

const { category: slug, id_category_default: id } = defineProps<Props>();

const breakpoints = {
  480: {
    slidesPerView: 1,
  },
  768: {
    slidesPerView: 2,
  },
  1024: {
    slidesPerView: 3,
  },
  1280: {
    slidesPerView: 4,
  },
};

const { fetchProducts, data, loading } = useProducts();

onMounted(async () => {
  await fetchProducts({ slug, id });
});

const products = computed(() => data.value?.products);
</script>

<template>
  <div>
    <VSection :title="heading" v-if="products && products.length > 0">
      <Swiper
        :breakpoints="breakpoints"
        navigation
        :space-between="20"
        :pagination="{ clickable: true }"
        :modules="[Navigation, Pagination]"
        class="pb-14! md:pb-10!"
      >
        <template v-if="loading">
          <SwiperSlide class="relative swiper-slide h-full">
            <Skeleton class="w-25 h-5 rounded-full" />
          </SwiperSlide>
        </template>
        <template v-else>
          <SwiperSlide v-for="product in products" :key="product.id">
            <VProductCard
              :product="product"
              :title="product.name"
              :image="product.coverImageMedium"
              seo-title-tag="h3"
            />
          </SwiperSlide>
        </template>
      </Swiper>
    </VSection>
  </div>
</template>
